import { jsx as a } from "react/jsx-runtime";
import r from "./icons/doc.svg.js";
import l from "./icons/generic.svg.js";
import p from "./icons/image.svg.js";
import f from "./icons/pdf.svg.js";
import d from "./icons/sheet.svg.js";
import v from "./icons/rtf.svg.js";
import N from "./icons/ppt.svg.js";
import g from "./style.module.less.js";
const I = (s) => {
  const { file: t, className: o, noContainer: c, containerClassName: n } = s;
  let m = "";
  if (t != null && t.id)
    m = t == null ? void 0 : t.mime;
  else {
    const i = s == null ? void 0 : s.file;
    m = i == null ? void 0 : i.type;
  }
  let e = null;
  if (m != null && m.startsWith("image/"))
    e = /* @__PURE__ */ a(p, { className: o ?? "" });
  else
    switch (m) {
      case "application/pdf":
        e = /* @__PURE__ */ a(f, { className: o ?? "" });
        break;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        e = /* @__PURE__ */ a(r, { className: o ?? "" });
        break;
      case "application/rtf":
        e = /* @__PURE__ */ a(v, { className: o ?? "" });
        break;
      case "application/vnd.ms-excel":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        e = /* @__PURE__ */ a(d, { className: o ?? "" });
        break;
      case "application/vnd.ms-powerpoint":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        e = /* @__PURE__ */ a(N, { className: o ?? "" });
        break;
      default:
        e = /* @__PURE__ */ a(l, { className: o ?? "" });
        break;
    }
  return c ? e : /* @__PURE__ */ a("div", { className: `${g.fileIconContainer} ${n ?? ""}`, children: e });
};
export {
  I as FileIcon
};
